// extracted by mini-css-extract-plugin
export default {"sideBarContainer":"brand-header-SideBar__sideBarContainer--PgU0u","jewel":"brand-header-SideBar__jewel--32h5y"};